/* HANIA v4 — deck pill strip, fast flick, stock guard, cart drawer qty */
(function () {
  'use strict';
  [].slice.call(document.querySelectorAll('[data-hx-deck]')).forEach(function (deck) {
    var list = deck.querySelector('.hx-deck__index'); if (!list) return;
    var links = [].slice.call(list.querySelectorAll('a[data-hx-goto]')); if (!links.length) return;
    function cur() { for (var i = 0; i < links.length; i++) { if (links[i].classList.contains('on')) return i; } return 0; }
    function center(smooth) {
      var a = links[cur()]; if (!a) return;
      var li = a.parentNode;
      list.scrollTo({ left: Math.max(0, li.offsetLeft - (list.clientWidth - li.offsetWidth) / 2), behavior: smooth ? 'smooth' : 'auto' });
    }
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function () { requestAnimationFrame(function () { center(true); }); });
      links.forEach(function (a) { mo.observe(a, { attributes: true, attributeFilter: ['class'] }); });
    }
    setTimeout(function () { center(false); }, 200);

    var md = false, mx = 0, ml = 0, mmoved = false;
    list.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse' || e.button !== 0) return; md = true; mmoved = false; mx = e.clientX; ml = list.scrollLeft; });
    window.addEventListener('pointermove', function (e) { if (!md) return; var d = e.clientX - mx; if (Math.abs(d) > 5) mmoved = true; if (mmoved) list.scrollLeft = ml - d; });
    window.addEventListener('pointerup', function () { if (md) { md = false; setTimeout(function () { mmoved = false; }, 40); } });
    list.addEventListener('click', function (e) { if (mmoved) { e.preventDefault(); e.stopPropagation(); } }, true);
    list.addEventListener('dragstart', function (e) { e.preventDefault(); });

    var stage = deck.querySelector('.hx-deck__stage');
    var nb = deck.querySelector('[data-hx-next]'), pb = deck.querySelector('[data-hx-prev]');
    var fx = null, fy = 0, ft = 0;
    if (stage) stage.addEventListener('pointerdown', function (e) {
      var c = e.target.closest('.hx-deck__card'); if (!c || !c.classList.contains('top')) { fx = null; return; }
      fx = e.clientX; fy = e.clientY; ft = Date.now();
    });
    window.addEventListener('pointerup', function (e) {
      if (fx == null) return;
      var dx = e.clientX - fx, dy = e.clientY - fy, dt = Date.now() - ft; fx = null;
      if (Math.abs(dx) > 18 && Math.abs(dx) <= 70 && Math.abs(dx) > Math.abs(dy) && dt < 320) {
        setTimeout(function () { var b = dx < 0 ? nb : pb; if (b) b.click(); }, 0);
      }
    });
  });
})();

/* Stock guard: never let a customer add more than the pieces in stock (per size) */
(function () {
  'use strict';
  var mapEl = document.getElementById('hx-stock-map');
  var STOCK = {}; try { STOCK = JSON.parse(mapEl.textContent); } catch (e) {}
  var root = (window.routes && window.routes.root_url) || '/'; if (root.slice(-1) !== '/') root += '/';
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function sizesOf(pid, activeId) {
    return Object.keys(STOCK).filter(function (k) { return STOCK[k].pid === pid; }).map(function (k) {
      return { title: STOCK[k].t, qty: STOCK[k].q, on: +k === +activeId };
    });
  }
  var pop = null, onAdd = null;
  function hide() { if (pop) pop.classList.remove('open'); onAdd = null; }
  function show(o) {
    if (!pop) {
      pop = document.createElement('div'); pop.className = 'hx-stock';
      pop.innerHTML = '<div class="hx-stock__box" role="dialog" aria-modal="true" aria-label="Limited stock"><button type="button" class="hx-stock__x" aria-label="Close">&times;</button><p class="hx-stock__eb">Limited pieces</p><h3 class="hx-stock__t"></h3><p class="hx-stock__m"></p><ul class="hx-stock__sizes"></ul><div class="hx-stock__btns"></div></div>';
      document.body.appendChild(pop);
      pop.addEventListener('click', function (e) {
        if (e.target === pop || e.target.closest('.hx-stock__x') || e.target.closest('[data-stock-ok]')) { hide(); return; }
        if (e.target.closest('[data-stock-add]')) { var f = onAdd; hide(); if (f) f(); }
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });
    }
    pop.querySelector('.hx-stock__t').textContent = o.title;
    pop.querySelector('.hx-stock__m').textContent = o.msg;
    var ul = pop.querySelector('.hx-stock__sizes');
    ul.innerHTML = (o.sizes || []).map(function (s) {
      return '<li class="' + (s.on ? 'on ' : '') + (s.qty <= 0 ? 'out' : '') + '"><span>' + esc(s.title) + '</span><b>' + (s.qty > 0 ? s.qty + ' available' : 'Sold out') + '</b></li>';
    }).join('');
    ul.style.display = (o.sizes && o.sizes.length) ? '' : 'none';
    onAdd = o.onAdd || null;
    pop.querySelector('.hx-stock__btns').innerHTML = (o.addN > 0 ? '<button type="button" class="hx-btn" data-stock-add>Add ' + o.addN + ' to Bag</button>' : '') +
      '<button type="button" class="hx-btn hx-btn--ghost" data-stock-ok>' + (o.addN > 0 ? 'Cancel' : 'OK') + '</button>';
    pop.classList.add('open');
  }
  window.hxStockPopup = show;
  function inCartQty(id) {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var n = 0; c.items.forEach(function (it) { if (it.variant_id === id) n += it.quantity; }); return n;
    }).catch(function () { return 0; });
  }
  function message(v, inCart, room) {
    var base = 'We have ' + v.q + ' piece' + (v.q === 1 ? '' : 's') + ' of ' + v.p + ' in size ' + v.t + '.';
    if (room <= 0) return inCart ? base + ' All ' + v.q + ' are already in your bag.' : v.p + ' is sold out in size ' + v.t + '. Please choose another size.';
    return base + (inCart ? ' You already have ' + inCart + ' in your bag, so you can add ' + room + ' more.' : ' You can add up to ' + room + '.');
  }
  function check(form, proceed) {
    var idIn = form.querySelector('[name="id"]'), qIn = form.querySelector('[name="quantity"]');
    var id = idIn ? parseInt(idIn.value, 10) : 0, v = STOCK[id];
    if (!v || !v.m) { proceed(); return; }
    var want = Math.max(1, parseInt(qIn && qIn.value, 10) || 1);
    inCartQty(id).then(function (inCart) {
      var room = v.q - inCart;
      if (want <= room) { proceed(); return; }
      show({ title: v.p + ' \u2014 Size ' + v.t, msg: message(v, inCart, room), sizes: sizesOf(v.pid, id), addN: Math.max(0, room),
        onAdd: function () { if (qIn) qIn.value = room; proceed(); } });
    });
  }
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f.matches || !f.matches('form[data-hs-ajax]')) return;
    if (f.dataset.hxOk === '1') { f.dataset.hxOk = ''; return; }
    e.preventDefault(); e.stopImmediatePropagation();
    check(f, function () { f.dataset.hxOk = '1'; if (f.requestSubmit) f.requestSubmit(); else f.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true })); });
  }, true);
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-hx-buynow]'); if (!b) return;
    if (b.dataset.hxOk === '1') { b.dataset.hxOk = ''; return; }
    var f = b.closest('form'); if (!f) return;
    e.preventDefault(); e.stopImmediatePropagation();
    check(f, function () { b.dataset.hxOk = '1'; b.click(); });
  }, true);
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-hx-pdp] [data-hx-q="1"]'); if (!b) return;
    var f = b.closest('form'); var idIn = f && f.querySelector('[name="id"]'); var v = idIn && STOCK[parseInt(idIn.value, 10)];
    var qIn = f && f.querySelector('[name="quantity"]'); if (!v || !v.m || !qIn) return;
    var q = parseInt(qIn.value, 10) || 1;
    if (q >= v.q) {
      e.preventDefault(); e.stopImmediatePropagation();
      show({ title: v.p + ' \u2014 Size ' + v.t, msg: 'Only ' + v.q + ' piece' + (v.q === 1 ? ' is' : 's are') + ' available in size ' + v.t + '.', sizes: sizesOf(v.pid, idIn.value), addN: 0 });
    }
  }, true);
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-hx-cart] [data-hx-line-q="1"]'); if (!b) return;
    if (b.dataset.hxOk === '1') return;
    var li = b.closest('.hx-li'); var line = parseInt(li.getAttribute('data-line'), 10);
    e.preventDefault(); e.stopImmediatePropagation();
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var it = c.items[line - 1]; var v = it && STOCK[it.variant_id];
      var total = 0; c.items.forEach(function (x) { if (it && x.variant_id === it.variant_id) total += x.quantity; });
      if (v && v.m && total >= v.q) {
        show({ title: v.p + ' \u2014 Size ' + v.t, msg: 'All ' + v.q + ' available pieces in size ' + v.t + ' are already in your bag.', sizes: sizesOf(v.pid, it.variant_id), addN: 0 });
      } else { b.dataset.hxOk = '1'; b.click(); }
    });
  }, true);
})();

/* Cart drawer: reliable +/− and remove (uses the line item key) */
(function () {
  'use strict';
  var root = (window.routes && window.routes.root_url) || '/';
  if (root.slice(-1) !== '/') root += '/';
  var busy = false;
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-hx-cart] [data-hx-line-q], [data-hx-cart] [data-hx-line-rm]');
    if (!b) return;
    b.dataset.hxOk = '';
    e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    if (busy) return;
    var li = b.closest('.hx-li'); if (!li) return;
    var line = parseInt(li.getAttribute('data-line'), 10);
    var span = li.querySelector('.hx-qty span');
    var q = parseInt(span ? span.textContent : '1', 10) || 0;
    var nq = b.hasAttribute('data-hx-line-rm') ? 0 : Math.max(0, q + parseInt(b.getAttribute('data-hx-line-q'), 10));
    if (span) span.textContent = nq;
    busy = true; li.style.opacity = '.55';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var item = cart.items[line - 1]; if (!item) throw { description: 'Please refresh the page.' };
        return fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: item.key, quantity: nq }) });
      })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .catch(function (err) {
        var m = err && (err.description || err.message);
        if (m && window.hxStockPopup) window.hxStockPopup({ title: 'Limited pieces', msg: m, sizes: [], addN: 0 });
      })
      .finally(function () { busy = false; document.dispatchEvent(new CustomEvent('cart:refresh')); });
  }, true);
})();
